function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#18ea95;}.b{fill:#18efa4;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0)"
}, React.createElement("g", {
  transform: "translate(3.481)"
}, React.createElement("path", {
  className: "a",
  d: "M-970.057,965.49a15.444,15.444,0,0,1-15.427-15.427,15.444,15.444,0,0,1,15.427-15.427,15.444,15.444,0,0,1,15.427,15.427A15.444,15.444,0,0,1-970.057,965.49Zm0-30.526a15.116,15.116,0,0,0-15.1,15.1,15.116,15.116,0,0,0,15.1,15.1,15.116,15.116,0,0,0,15.1-15.1A15.116,15.116,0,0,0-970.057,934.964Z",
  transform: "translate(985.484 -934.636)"
})), React.createElement("g", {
  transform: "translate(29.585 26.103)"
}, React.createElement("rect", {
  className: "a",
  width: 0.328,
  height: 20.584,
  transform: "translate(0 0.232) rotate(-45)"
})), React.createElement("g", {
  transform: "translate(0 5.181)"
}, React.createElement("path", {
  className: "b",
  d: "M-1006.448,986.48l-.274-.18,7.758-11.813,9.052,9.052,5.971-8.909,6.9-.048,8.338-8.338.232.232-8.433,8.433-6.865.048-6.1,9.1L-998.911,975Z",
  transform: "translate(1006.722 -966.244)"
})), React.createElement("g", {
  transform: "translate(6.765 12.814)"
}, React.createElement("rect", {
  className: "b",
  width: 1.826,
  height: 1.826
})), React.createElement("g", {
  transform: "translate(15.923 21.681)"
}, React.createElement("rect", {
  className: "b",
  width: 1.826,
  height: 1.826
})), React.createElement("g", {
  transform: "translate(28.788 12.814)"
}, React.createElement("rect", {
  className: "b",
  width: 1.826,
  height: 1.826
})), React.createElement("g", {
  transform: "translate(21.992 12.814)"
}, React.createElement("rect", {
  className: "b",
  width: 1.826,
  height: 1.826
})));

var SvgConsulting = function SvgConsulting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 44.372,
    height: 40.89,
    viewBox: "0 0 44.372 40.89",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConsulting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Consulting.3e78a1da.svg";
export { ForwardRef as ReactComponent };